<template>
  <div>
    <ProductVisual v-bind="group"/>

    <div class="container">
      <span class="tag" v-if="group.slug === 'silent'">Parkdeck</span>
      <span class="tag" v-else>Tiefgarage</span>
    </div>
    <div class="section">
      <div class="container">
        <p v-html="text" class="longtext" />
      </div>
    </div>
    <section class="section" >
      <div class="container">
        <carousel class="slider" :centerMode="true" :perPage="1" :perPageCustom="[[768, 2]]">
          <slide class="slider__item" v-for="(result, index) in slider" v-bind:key="index">
            <ResultTeaser v-bind="result" />
          </slide>
        </carousel>
      </div>
    </section>
  </div>
</template>

<script>
import ProductVisual from '@/components/ProductVisual.vue';
import ResultTeaser from '@/components/finder/ResultTeaser.vue';
import products from '@/assets/json/products.json';
import groups from '@/assets/json/groups.json';

export default {
  components: {
    ProductVisual,
    ResultTeaser,
  },
  data() {
    const allProducts = Object.keys(products)
      .map(k => products[k])
      .filter(o => o.slug === this.$route.params.id);

    const group = groups.find(o => o.slug === this.$route.params.id);

    return {
      group,
      text: group.longtext,
      slider: allProducts,
    };
  },
};
</script>

<style scoped lang="scss">
.slider {
  margin: 0 -#{$container-padding / 2};
  text-align: left;

  &__item {
    width: 100%;
    display: flex;
    padding: 0 $container-padding / 2;

    .result-teaser {
      border: 1px solid $color-black;
    }
  }
}
.groupinfo {
  text-align: left;
  padding: 0;
  margin: 0;
  margin-bottom: 45px;
}
.tag {
  font-family: $font-bold;
  text-align: center;
  background-color: $color-primary;
  display: inline-block;
  padding: 13px 15px 9px;
  width: auto;
  color: $color-white;
  margin-bottom: 24px;
}
.longtext {
  text-align: left;
  margin: 0;
}
</style>
